import axios from "axios";

const SWAxios = axios.create()

// Firebase settings
import { initializeApp, getApps } from "firebase/app"
import { getMessaging } from "firebase/messaging/sw";
import { getToken } from "firebase/messaging";
import { firebaseConfig } from '../../../../customer.json' with { type: "json" }
import { $emit } from '../event-bus';

export function isPushSetUp() {
	// Let's check if the we have push notitications enabled
	return !!firebaseConfig.apiKey
}

export function isPushDenied() {
	// Let's check if the browser supports notifications
	return "Notification" in window && Notification.permission === 'denied'
}

export function isPushNotDenied() {
	// Let's check if the browser supports notifications
	return "Notification" in window && Notification.permission !== 'denied'
}

export function isGranted() {
	// Let's check if the browser supports notifications
	return "Notification" in window && Notification.permission === 'granted'
}

export const initializeFirebaseSw = async () => {
	// The app is initialized already
	if (getApps().length) return;

	// Handle push notification
	self.addEventListener('push', event => {
		var data = {}
		
		try{
			data = event.data?.json()?.data || event.data?.json()?.notification
		}catch(e){ // Set default values if things fails 
			data.body = event.data.text()
		}

		event.waitUntil(self.registration.showNotification(data.title || "", {
			body: data?.body || "",
			icon: data?.icon || "/customer/icons/icon192.png",
			tag: "vibration-sample",
			data: {
				clickUrl: data?.click_action
			}
		}))
	})

	// Handle click on push notification
	self.addEventListener("notificationclick", event => {
		const url = event.notification?.data?.clickUrl || "/"

		// This looks to see if the current is already open and
		// focuses if it is
		event.waitUntil(
			clients.matchAll({
				includeUncontrolled: true,
				type: "window",
			})
			.then(clientList => {
				// Look for an already opened window to focus it
				for (const client of clientList) {
					if (client.url === url && "focus" in client) return client.focus();
				}

				// Otherwise open a new window
				if (clients.openWindow) return clients.openWindow(url);
			}),
		);

		// Close notification
		event.notification.close();
	});
}

export const initializeFirebase = async () => {
	// The app is initialized already
	if (getApps().length) return;

	// Firebase not enabled
	if (!firebaseConfig?.apiKey) return;

	const firebaseApp = initializeApp(firebaseConfig)
	const messaging = getMessaging(firebaseApp);

	return await getToken(messaging, {
		vapidKey: firebaseConfig?.vapidKey,
		serviceWorkerRegistration: await navigator.serviceWorker.ready,
	})
}

export const savePushTokenToServer = (token: string) => {
	// Send push token to the server
	return SWAxios.post('/api/user-side/savePushToken', {
		token,
		user_agent: window.navigator.userAgent
	})
}

export const enablePushNotifications = async () => {
	try {
		const token = await initializeFirebase()
		
		if(token){
			savePushTokenToServer(token)
			$emit("push-notifications-changed")
		}
	} catch (error) {
		$emit("push-notifications-changed")
		console.error(error);
	}
}